import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  ViewChild,
  ViewChildren,
  QueryList,
  Output
} from '@angular/core';
import saveAs from 'file-saver';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';
import { PartnerBulkEmailTracking } from '../../../models/partner-bulk-email-tracking.model';
import { AppConstants } from '../../common/app-constants';
import { SettingsService } from '../../common/settings.service';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-email-batch-history-table',
  templateUrl: './email-batch-history-table.component.html',
  styleUrls: ['./email-batch-history-table.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class EmailBatchHistoryTableComponent implements OnInit {
  scrollableCols = new Array<any>();
  globalFilterCols = new Array<any>();
  loadingIcon = 'fa-circle-o-notch';
  pageLinksPerPage!: number;
  dataViewRecsPerPage!: number;
  tblPageNumber!: number;
  totalRecords!: number;
  display!: boolean;
  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  showFullscreen = false;
  canShowPreviewModel!: boolean;
  excelLoading = false;
  currentPageInfo!: string;
  pscols!: any[];
  @Input() refreshData!: Subject<boolean>;
  @ViewChild('dt', { static: false }) dt!: Table;
  @Input() loading!: boolean;
  @Input() partnerBulkEmailTrackingList: PartnerBulkEmailTracking[] = [];
  @Input() prevDocumentType!: string;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;
  @Output() refreshList = new EventEmitter();
  sortableColumnForUploadedDate!: string;

  constructor(
    public localStorage: LocalStorageService,
    private osmService: OsmosisService,
    public settings: SettingsService
  ) {}

  ngOnInit() {
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.display = false;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();
    this.loadPartnerBulkEmailTrackList();

    this.refreshData.subscribe(() => {
      this.loadPartnerBulkEmailTrackList();
    });
  }

  loadPartnerBulkEmailTrackList() {
    this.loading = true;
    this.osmService.getPartnerBulkEmailHistory().subscribe(serviceOutput => {
      if (
        serviceOutput === null ||
        serviceOutput.length === null ||
        serviceOutput.length === 0
      ) {
        this.loading = false;
      } else {
        this.partnerBulkEmailTrackingList = serviceOutput;
        this.totalRecords = this.partnerBulkEmailTrackingList.length;

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        this.loading = false;
      }
    });
    this.pscols = [
      { field: 'templateName', header: 'Name' },
      { field: 'recipientCategoryName', header: 'Recipients' },
      { field: 'emailSentDate', header: 'Date' },
      { field: 'status', header: 'status' }
    ];

    this.globalFilterCols = [
      'templateName',
      'recipientCategoryName',
      'emailSentDate',
      'status'
    ];
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }
  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  refresh() {
    this.refreshList.emit(true);
  }

  getPartnerBulkEmailExportData(emailBatchId: number) {
    this.loading = true;
    this.osmService
      .getPartnerBulkEmailExportData(emailBatchId)
      .subscribe(downloadFile => {
        this.loading = false;
        const file = new Blob([downloadFile], { type: 'blob' });
        saveAs(file, 'RecipientPartners' + '.zip');
      });
  }

  export(emailBatchId: number) {
    console.log(emailBatchId);
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'paymentBatchName';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }

    if (
      this.partnerBulkEmailTrackingList === null ||
      this.partnerBulkEmailTrackingList.length === 0
    ) {
      this.totalRecords = 0;
      this.currentPageInfo = '';
    } else {
      this.loadPartnerBulkEmailTrackList();
      this.totalRecords = this.partnerBulkEmailTrackingList.length;
      if (this.totalRecords > 0 && this.totalRecords > this.totalRecords) {
        this.currentPageInfo = '';
      }

      if (this.totalRecords > 0 && this.totalRecords <= this.totalRecords) {
        this.currentPageInfo = '';
      }
    }
  }
}
